export default __webpack_public_path__ + "static/media/Background_00014.e82cda67.png";